import script from "./IconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=ts"

import "./IconButton.vue?vue&type=style&index=0&id=3c542804&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c542804"]])

export default __exports__